import { connect } from 'react-redux';

import { actionCreators } from 'dux/apitokens';
import ApiTokenItem from './ApiTokenItem';

const mapDispatchToProps = {
  onTokenDelete: actionCreators.deleteToken,
};

export default connect(null, mapDispatchToProps)(ApiTokenItem);
